export const en = {
    // Sidebar menu
    home: 'Dashboard',
    learningCorner: 'Learning Corner',
    fullMockTests: 'Journey / Mock Tests',
    skillPractice: 'Skill Practice',
    skillMap: 'Skill Map',
    recentActivity: 'History & Review',
    library: 'Library',
    report: 'Weekly Report',
    settings: 'Settings',
    logout: 'Logout',

    // Dashboard
    choosePath: 'Learning Path',
    learningCornerTitle: 'Learning Corner',
    learningCornerDesc: 'Strengthen your Flyers vocabulary and grammar with focused exercises, topic-based word lists, and interactive drills.',
    learningCornerCta: 'Study Now',
    skillPracticeTitle: 'Skill Practice',
    skillPracticeDesc: 'Sharpen your Listening, Reading & Writing, and Speaking skills with targeted practice sets aligned to the Flyers exam format.',
    skillPracticeCta: 'Start Now',
    fullMockTestTitle: 'Full Mock Test',
    fullMockTestDesc: 'Take a full-length mock exam that mirrors the real Flyers test — timed, structured, and scored just like the actual exam.',
    fullMockTestCta: 'Take Test',
    welcome: 'Welcome',
    today: 'Today',
    level: 'Level',
    streak: 'Streak',
    stars: 'Stars',
    shields: 'Shields',
    days: 'days',
    dailyQuests: 'Daily Quests',
    quickPractice: 'Quick Practice',
    quickPracticeDesc: 'AI selects suitable lessons • 5-10 mins',
    quickPracticeCta: '1 click → start quiz now! ⚡',
    start: 'Start',
    fullMockExam: 'Full Mock Exam',
    fullMockExamDesc: 'Simulate the real exam • 45 mins',
    fullMockExamCta: 'Experience real exam room 🏆',
    selectExam: 'Select Exam',
    overallProgress: 'Overall Progress',
    viewLibrary: 'View Library',
    noData: 'No learning data yet',
    doExercises: 'Do exercises to track progress!',
    weaknesses: 'Weaknesses to improve',
    noWeaknesses: 'Well done! No weaknesses detected',
    keepGoing: 'Keep practicing for more detailed analysis',
    trained: 'Trained',
    times: 'times',
    train: 'Train',
    suggestions: 'Suggestions for you today',
    noSuggestions: 'No personalized suggestions yet',
    doMore: 'Do more exercises for AI analysis!',
    recentActivityTitle: 'Recent Activity',
    viewAll: 'View All',

    // Settings
    settingsTitle: 'Settings',
    accountSection: 'Account',
    generalSection: 'General',
    levelLabel: 'Level',
    languageLabel: 'Language',
    languageSub: 'Choose display language',
    logoutSub: 'Sign out of your account',
    confirmLogoutTitle: 'Log out?',
    confirmLogoutMsg: 'Are you sure you want to log out?',
    cancel: 'Cancel',
    version: 'Version',
    verified: 'Verified',
    user: 'User',

    // Full Test Attempt
    exit: 'Exit',
    part: 'Part',
    question: 'Question',
    hint: 'Hint',
    showHint: 'Show Hint',
    hideHint: 'Hide Hint',
    fillCorrectAnswer: 'Fill Correct Answer',
    timer: 'Timer',
    loading: 'Loading...',
    gradingTitle: 'Teacher is grading...',
    gradingDesc: 'Please wait a moment. The AI system is analyzing your work.',
    next: 'Next',
    previous: 'Previous',
    finish: 'Finish',
    submitAndResult: 'Submit & See Results 🎉',
    back: 'Back',
    review: 'Review',
    great: 'Great! 🎉',
    completedSection: 'You have completed section',
    readyForNext: 'Ready for the next challenge? ⭐',
    importantNote: 'Important Note',
    cannotGoBack: 'After moving to the next section, you cannot go back to edit your answers in this section.',
    finalStretch: 'Final Stretch',
    completedAllSections: 'You have completed all sections! Click the button below to submit and see your results.',
    reviewMode: 'Review Mode',
    reviewFinished: 'You have finished reviewing this section.',
    reviewModeDesc: 'Click the button below to move to the next section review.',
    reviewAllFinished: 'You have reviewed the entire exam!',
    backToResult: 'Back to Result',
    nextSection: 'Next Section →',

    // Left Panel
    audioTrack: 'Audio Track',
    playing: 'Playing...',
    wordBank: 'Word Bank',
    colorPalette: 'Color Palette',
    fillWord: 'Fill word',
    dragToImage: 'Drag the text box into the correct places, then write the correct word.',
    dragBox: 'Drag to image',
    typeWord: 'type word...',
    answerChoices: 'Answer Choices',
    chooseCorrectWords: 'Options',
    noNo: 'No.',
    optionA: 'Option A',
    optionB: 'Option B',
    optionC: 'Option C',
    error: 'Error',

    // Language names
    langLabel: 'English',
    langFlag: '🇬🇧',

    // Full Test Result
    testCompleted: 'Exam Completed!',
    excellentResult: 'Excellent! Here is your result.',
    overallScore: 'Overall Score',
    accuracy: 'Accuracy',
    attempted: 'Attempted',
    skipped: 'Skipped',
    sectionDetails: 'Section Details',
    scoreLabel: 'Score',
    perfectSection: 'Great! Perfect score in this section',
    reviewAttempt: 'Review Attempt',
    backToHome: 'Back to Home',
};
